import React from 'react';
import PropTypes from 'prop-types';
import { ZCDTable } from '@zencity/common-ui';
import zip from 'lodash/zip';

function DistributionTable(props) {
  const { question } = props;
  const { datasets } = question.data;

  const tableData = question.data.datasets.map((dataset) => ({
    title: dataset.title,
    values: zip(dataset.counts, dataset.percentages).map(([count, percentage]) => (
      <>
        {percentage}%<br />
        {count}
      </>
    )),
  }));

  const columnArray = [
    { Header: 'Line Item', accessor: 'title', width: false },
    ...datasets[0].labels.map((label, index) => ({
      Header: label,
      accessor: `values[${index}]`,
      width: false,
    })),
  ];

  return (
    <div>
      <h4 className="engage-results-engagement-screen__chart-content__subtitle">Distribution</h4>
      <ZCDTable columnArray={columnArray} tableData={tableData} maxItemsLimit={10} />
    </div>
  );
}

DistributionTable.propTypes = {
  question: PropTypes.shape({
    data: PropTypes.shape({
      averages: PropTypes.shape({
        labels: PropTypes.arrayOf(PropTypes.string).isRequired,
        values: PropTypes.arrayOf(PropTypes.number).isRequired,
        percentages: PropTypes.arrayOf(PropTypes.number).isRequired,
      }).isRequired,
      datasets: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          labels: PropTypes.arrayOf(PropTypes.string).isRequired,
          counts: PropTypes.arrayOf(PropTypes.number).isRequired,
          percentages: PropTypes.arrayOf(PropTypes.number).isRequired,
          statistics: PropTypes.shape({
            min: PropTypes.number.isRequired,
            max: PropTypes.number.isRequired,
            median: PropTypes.number.isRequired,
            mean: PropTypes.number.isRequired,
            stdDev: PropTypes.number,
            meanDiff: PropTypes.number,
            comparisonValueLabel: PropTypes.string.isRequired,
            comparisonValue: PropTypes.number,
            mode: PropTypes.number.isRequired,
          }).isRequired,
        }).isRequired
      ).isRequired,
    }).isRequired,
  }).isRequired,
};

export default DistributionTable;
